exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".action-col-w-13 {\n  width: 13%; }\n\n.variance-col-width-10 {\n  width: 10%; }\n\n.remove-group-btn-color {\n  color: #333 !important;\n  background-color: #fff !important;\n  border-color: #ccc !important; }\n\n.variance-bg-color {\n  background-color: #ff000024; }\n\n.authorized-residual-btn-section {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px; }\n\n.deposit-table-view thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: #969696;\n  color: #fff;\n  font-size: 14px; }\n\n.autorize-view-header {\n  background-color: #969696;\n  color: #fff;\n  font-size: 14px; }\n\n.branch-mgmt-final-residual-count-commit .denom-width {\n  width: 20%; }\n\n.denom-position-final-residual-count-commit {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  flex-wrap: wrap;\n  gap: 15px 2%;\n  padding: 10px 15px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/final_residual_count_commit/final_residual_count_commit.scss
// module id = 992
// module chunks = 1